import { Injectable } from "@angular/core";
import { ComponentCourse } from "@data/course";
import { courseCatalogSearchResult, ServiceResponse } from "@data/index";
import { API } from "@service/system/api.service";
import { HttpManager } from "@service/system/httpManager.service";
import { ResponseHandler } from "@service/system/responseHandler.service";
import { Observable } from "rxjs";

const API_URL = API.API_URL;

@Injectable()
export class SearchService {
  private _searchURL = API_URL;

  constructor(private httpManager: HttpManager, private responseHandler: ResponseHandler) {}

  searchOrgs(): Observable<any> {
    return this.httpManager.httpGet<any>(`${this._searchURL}/organizations`, { status: status });
  }

  searchCourses(): Observable<any> {
    return this.httpManager.httpGet<any>(`${this._searchURL}/courses`, { status: status });
  }

  searchComponentCourses(searchTerm: string): Observable<ServiceResponse<ComponentCourse[]>> {
	return this.responseHandler.httpGet<ComponentCourse[]>(`${this._searchURL}/component/courses/search`, { searchTerm: searchTerm });
  }

  searchCourseContent(b64EncodedString: string, caseSensitive: boolean = false): Observable<ServiceResponse<courseCatalogSearchResult[]>> {
	return this.responseHandler.httpGet<courseCatalogSearchResult[]>(`${this._searchURL}/tools/catalog_search`, { encodedSearchQuery: b64EncodedString, caseSensitive: caseSensitive });
  }
}
